// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteModel_wrapper__1SgTS","delete_img":"DeleteModel_delete_img__2my+N","text":"DeleteModel_text__TqkHS","del":"DeleteModel_del__SfR0X"};